let SubNavigation = {};

SubNavigation = {
    init() {
        let $subNavigationSlider = $('.js-sub-navigation-slider');

        if ($subNavigationSlider.length === 0) {
            return;
        }

        $.each($subNavigationSlider, function () {
            let $slider = $(this);
			let slideCount = $slider.children().length;
            $slider.flickity({
                pageDots: false,
                groupCells: false,
                cellAlign: slideCount <= 4 ? 'center' : 'left',
                percentPosition: false,
                wrapAround: false,
                contain: true,
                dragThreshold: 10,
				prevNextButtons: false,
                on: {
                    ready: function ready() {
                        $slider.closest('.sub-navigation').removeClass('is-hidden').addClass('is-loaded');
                    },
                },
            });
        });
    },
}

$(function () {
    SubNavigation.init();

    window.addEventListener('resize', window.stokpress.debounce(function () {
        SubNavigation.init();
    }, 500));

});

window.SubNavigation = SubNavigation;



// WEBPACK FOOTER //
// ./scripts/components/sliders/sub-navigation.js